import { defineModel } from "../define-model";

export type AssistantMessagePart =
	| { type: "stopped" }
	| { type: "error"; message: string; code?: string }
	| { type: "context"; path?: string; label?: string }
	| { type: "notice"; reason: "max_steps" };

export type AssistantMessage = {
	id: string;
	workspaceId: string;
	threadId: string;
	projectId: string | null;
	role: "system" | "user" | "assistant" | "tool";
	content: string;
	parts: AssistantMessagePart[];
	status: "pending" | "streaming" | "complete" | "error";
	model: string | null;
	generationId: string | null;
	costUsd: number;
	millicredits: number;
	createdById: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		assistantMessage: AssistantMessage;
	}
}

export const model = defineModel({
	name: "assistantMessage",
	load: "lazy",
	indexes: ["threadId"],
	sort: (a, b) => a.createdAt.localeCompare(b.createdAt) || a.id.localeCompare(b.id),
});
